import { useState, useEffect } from 'react';
import { Delete as TrashIcon, Search as SearchIcon } from '@mui/icons-material';
import { SearchInput, GlobalButton } from '@/components';
import { GlobalButtonVariant } from '@/components/buttons/GlobalButton';
import { CommerceSettingsFilters } from '../models';

interface CommerceSettingsSearchBarProps {
  initialFilter: CommerceSettingsFilters;
  filter: CommerceSettingsFilters;
  search: (filter: CommerceSettingsFilters) => void;
}

const CommerceSettingsSearchBar = ({
  initialFilter,
  filter,
  search,
}: CommerceSettingsSearchBarProps) => {
  const [localFilter, setLocalFilter] =
    useState<CommerceSettingsFilters>(filter);

  useEffect(() => {
    setLocalFilter(filter);
  }, [filter]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      const normalized: CommerceSettingsFilters = {
        ...localFilter,
        key: localFilter.key ? localFilter.key.toLowerCase() : localFilter.key,
      };
      search(normalized);
    }, 300);

    return () => clearTimeout(timeoutId);
  }, [localFilter.key]);

  const handleSearch = () => {
    search(localFilter);
  };

  const resetFilters = () => {
    setLocalFilter(initialFilter);
    search(initialFilter);
  };

  return (
    <div className='w-full p-5 bg-white rounded-lg shadow-md'>
      <div className='flex flex-col gap-4'>
        <div className='flex gap-2.5'>
          <SearchInput
            name='commerce-settings-key-search'
            placeholder='Buscar por llave'
            value={localFilter.key || ''}
            onChange={(value) =>
              setLocalFilter((prev: CommerceSettingsFilters) => ({
                ...prev,
                key: value,
              }))
            }
          />
          <SearchInput
            name='commerce-settings-value-search'
            placeholder='Buscar por valor'
            value={localFilter.value || ''}
            onChange={(value) =>
              setLocalFilter((prev: CommerceSettingsFilters) => ({
                ...prev,
                value: value,
              }))
            }
          />
        </div>
        <div className='flex gap-2 justify-end'>
          <GlobalButton
            variant={GlobalButtonVariant.secondaryButton}
            action={resetFilters}
          >
            <TrashIcon />
            Limpiar
          </GlobalButton>
          <GlobalButton
            variant={GlobalButtonVariant.primaryButton}
            action={handleSearch}
          >
            <SearchIcon />
            Buscar
          </GlobalButton>
        </div>
      </div>
    </div>
  );
};

export default CommerceSettingsSearchBar;
